// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Wy4vU","content":"styles_content__7BLwo","text":"styles_text__lwfg+"};